/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExerciseFactDTO
 */
export interface ExerciseFactDTO {
    /**
     * 
     * @type {string}
     * @memberof ExerciseFactDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseFactDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseFactDTO
     */
    exerciseId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseFactDTO
     */
    glossaryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExerciseFactDTO
     */
    description: string;
}

/**
 * Check if a given object implements the ExerciseFactDTO interface.
 */
export function instanceOfExerciseFactDTO(value: object): value is ExerciseFactDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ExerciseFactDTOFromJSON(json: any): ExerciseFactDTO {
    return ExerciseFactDTOFromJSONTyped(json, false);
}

export function ExerciseFactDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseFactDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'exerciseId': json['exerciseId'] == null ? undefined : json['exerciseId'],
        'glossaryIds': json['glossaryIds'] == null ? undefined : json['glossaryIds'],
        'description': json['description'],
    };
}

export function ExerciseFactDTOToJSON(json: any): ExerciseFactDTO {
    return ExerciseFactDTOToJSONTyped(json, false);
}

export function ExerciseFactDTOToJSONTyped(value?: ExerciseFactDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'exerciseId': value['exerciseId'],
        'glossaryIds': value['glossaryIds'],
        'description': value['description'],
    };
}

